import { Avatar, Stack, Typography } from '@mui/material';
import { IFormMetaData, IUploadFileList } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleOutlinedAlert } from 'Images';
import { FileUpload } from '../FileUpload';
import { Fragment, useContext, useEffect } from 'react';
import { RequestsContext } from 'Context';

interface IUploadFilesList {
  formMetaData: IFormMetaData | undefined;
}

export const UploadFilesList = ({ formMetaData }: IUploadFilesList) => {
  const { setRequestsData } = useContext(RequestsContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.Requests);
  const isDesktop = useIsDesktop();

  useEffect(() => {
    setRequestsData((prevRequestData) => ({
      ...prevRequestData,
      fieldAttachmentsData: [],
    }));
  }, [setRequestsData]);

  return (
    <Stack gap={'32px'}>
      <Stack
        bgcolor={isDesktop ? 'transparent' : 'purple2.shade_50'}
        borderRadius={'12px'}
        direction={'row'}
        padding={isDesktop ? '0' : '16px'}
        gap={'12px'}
      >
        <Avatar
          src={PurpleOutlinedAlert}
          sx={{ width: '20px', height: '20px' }}
        />
        <Stack direction={'row'} alignItems={'flex-start'}>
          <Typography variant={'body6'} tabIndex={0}>
            {dictionary.Step1.list1}
          </Typography>
        </Stack>
      </Stack>
      <Stack gap={'32px'} component={'ul'} margin={0} padding={0}>
        {formMetaData?.attachments &&
          formMetaData?.attachments?.length > 0 &&
          formMetaData?.attachments.map(
            (value: IUploadFileList, index: number) => {
              return (
                <Fragment key={index}>
                  <Stack
                    data-index={index}
                    bgcolor={isDesktop ? 'transparent' : 'primary.shade_100'}
                    borderRadius={'16px'}
                    gap={'16px'}
                    component={'li'}
                    padding={isDesktop ? '0' : '20px 16px'}
                    margin={0}
                  >
                    <Typography
                      id={`item-text-${index}`}
                      variant={'body1'}
                      tabIndex={0}
                    >
                      {value.name}
                      {!value.requiredFieldGroupId &&
                        value.isRequired &&
                        dictionary.required}
                    </Typography>
                    <FileUpload
                      fieldIndex={index}
                      fieldId={value.id}
                      fieldTitle={value.name}
                      dataRequired={value.isRequired}
                      dataRequiredWith={value.requiredWith}
                    />
                  </Stack>
                </Fragment>
              );
            }
          )}
      </Stack>
    </Stack>
  );
};
